import React, { createContext, useContext, useEffect, useState } from 'react'

export enum Unit {
  Imperial,
  Metric,
}

type UnitPreferenceContext = {
  unitPreference: Unit
  toggleUnitPreference: () => void
}

export const UnitPreference = createContext({} as UnitPreferenceContext)

export function UnitPreferenceProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const savedUnitPreference = localStorage.getItem('unitPreference')
  const [unitPreference, setUnitPreference] = useState<Unit>(
    savedUnitPreference ? JSON.parse(savedUnitPreference) : Unit.Imperial,
  )

  useEffect(() => {
    localStorage.setItem('unitPreference', JSON.stringify(unitPreference))
  }, [unitPreference])

  function toggleUnitPreference() {
    setUnitPreference((s) =>
      s === Unit.Imperial ? Unit.Metric : Unit.Imperial,
    )
  }

  return (
    <UnitPreference.Provider value={{ unitPreference, toggleUnitPreference }}>
      {children}
    </UnitPreference.Provider>
  )
}

export function useUnitPreference() {
  return useContext(UnitPreference)
}
